<form [formGroup]="form">
  <mat-form-field>
    <mat-label>Ответ</mat-label>
    <textarea matInput formControlName="text"
              placeholder="Введите ответ"
              [autofocus]="['autofocus']"
              cdkTextareaAutosize
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"
              rows="2"></textarea>
  </mat-form-field>
</form>
